import PrimaryButton from './PrimaryButton'

class PagePrimaryButton extends PrimaryButton {}
export default PagePrimaryButton



// WEBPACK FOOTER //
// ./src/components/PagePrimaryButton.js